import './Contact.css'
import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
// import ListItem from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';

const links = [
    {
        title: "Gmail",
        href: "mailto:boulouktwalid@gmail.com",
        icon: "fa-brands fa-google fa-2x"
    },
    {
        title: "LinkedIn",
        href: "https://linkedin.com/in/walidbouloukt",
        icon: "fa-brands fa-linkedin fa-2x"
    },
    {
        title: "Twitter",
        href: "https://twitter.com/Walid_Blkt",
        icon: "fa-brands fa-twitter fa-2x"
    },
    {
        title: "Github",
        href: "https://github.com/Walid-pro",
        icon: "fa-brands fa-github fa-2x"
    }
];




export default function Contact() {


  return (
    <div className="contact-container">
    <div className="row contact-parent">
        <div className="col-12 col-md-10">
            <span className="contact-headline">
                <h1>Get In <span className="underline">Touch</span></h1>
            </span>

            <span className="contact-subheading">
            <p>Whether you have a specific web development requirement, an exciting collaboration opportunity, or simply want to connect and explore potential avenues of working together, I am here to listen and respond promptly.
            <br/>
            Thank you for considering my portfolio, and I look forward to connecting with you soon.                 
            </p>

            <Typography>
            Contact Information:
            </Typography>
            <List sx={{ pt: 0 }}>
            {links.map((link) => (
                <ListItem disableGutters>
                    {/* <ListItem> */}
                    {/*    <ListItemAvatar>
                            <Avatar sx={{ bgcolor: "#0A4D68"}}>
                                <i className={link.icon}></i>
                            </Avatar>
                        </ListItemAvatar>
                        */}
                        <a href={link.href} className="contact-btn" rel="noreferrer" target="_blank">
                        <i className={`icon ${link.icon}`}></i>
                        <Typography className="text" sx={{ color: "cornsilk" }}>
                        {link.title}
                        </Typography>
                        </a>
                    {/* </ListItem> */}
                </ListItem>
            ))}

        </List>
            
    
        </span>

        </div>

    </div>
</div>
  );
}